






























import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, computed } from '@vue/composition-api';
import { useGetter } from 'common-module/src/util/useVuex';
import { useInstance } from 'common-module/src/util/useInstance';
import eventBus from '@/plugins/eventBus';

import CommonNoticeCard from '@/components/notice/CommonNoticeCard';
import * as permission from 'common-module/src/config/permission';

export default defineComponent({
  name: 'RightRecorderNoticeCard',
  components: { CommonNoticeCard },
  bemNS: theme.bemNS,
  props: {
    adminContentText: {
      type: String,
      default: ''
    },
    memberContentText: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const instance = useInstance();
    const hasUpgradePermission = computed(() => useGetter('user/checkAccessPermission')(permission.upgrade));

    const contentText = computed(() => hasUpgradePermission.value ? props.adminContentText : props.memberContentText);

    return {
      contentText,
      hasUpgradePermission,
      showActions: computed(() => hasUpgradePermission.value && !instance.$store.getters.isAWSUserMark),
      toUpgrade: () => {
        eventBus.$emit('global:openUpgradeDialog');
        instance.$parent.close();
      }
    };
  }
});
